const __version__ ='premera_v1.0.0'

module.exports = {
    __version__
}

